import _ from "underscore";
import { MobileActions } from "../../store/mobile/actions";
import { PageLevel } from "../../store/mobile/types";
import pageHTML from "./main.tmpl";
import { DataActions } from "../../store/data/actions";
import DebugPageView from "./debugPageView";
import { clearAllFeatureFlagOverrides } from "../../utils/featureFlagOverrides";

// Set to true before navigating here via the version-tap gesture so the page
// can briefly suppress input and prevent tap momentum from triggering a menu item.
export let arrivedFromVersionTap = false;
export function setArrivedFromVersionTap() { arrivedFromVersionTap = true; }

    export default class DebugView extends DebugPageView {
        private readonly template = _.template(pageHTML);
        private readonly databaseCache;

        constructor (options) {
            super(options);
            this.databaseCache = this.app.databaseCache;

            this.storeUnsubscribe = this.app.observeStore(state => {
                return [
                    state.data.debugMode
                ];
            }, this.render.bind(this));
        }

        /* eslint-disable @typescript-eslint/unbound-method */
        events() {
            return {
                "click #status": this.status,
                "click #flags": this.flags,
                "click #gpsDebug": this.gpsDebug,
                "click #localStorageDebug": this.localStorageDebug,
                "click #featureFlags": this.featureFlags,
                "click #debugLogs": this.debugLogs,
                "click #drivingSimulator": this.drivingSimulator,
                "click #nativeDebug": this.nativeDebug,
                "click #offline": this.offline,
                "click #resetAddins": this.resetAddins,
                "click #debugToggleButton": this.debugToggle,
                "click #backgroundTest": this.backgroundTest,
                "click #vehicleProximity": this.vehicleProximity,
                "click #mocks": this.mocks,
                "click #notifications": this.notifications,
                "click #errors": this.errors,
                "click #ioxUsb": this.ioxUsb,
                "click #imagesDebug": this.images,
                "click #addin": this.addin,
                "click #webSocketDebug": this.webSocketDebug,
                "click #zenHosMain": this.zenHosMain
            } as Backbone.EventsHash;
        }
        /* eslint-enable @typescript-eslint/unbound-method */

        render () {
            this.el.innerHTML = this.template({
                debugMode: this.app.store.getState().data.debugMode
            });

            if (arrivedFromVersionTap) {
                arrivedFromVersionTap = false;
                this.el.classList.add("debug-input-paused");
                setTimeout(() => this.el.classList.remove("debug-input-paused"), 800);
            }

            this.app.store.dispatch(MobileActions.setPageState({
                title: "Debug",
                activeSection: "debug",
                pageLevel: PageLevel.SUBMENU_WITH_BACK_BUTTON
            }));

            return this;
        }

        debugToggle () {
            let newState = !this.app.store.getState().data.debugMode;
            this.app.store.dispatch(DataActions.setDebugMode(newState));

            // Clear feature flag overrides when debug mode is turned off
            if (!newState) {
                clearAllFeatureFlagOverrides();
            }
        }

        status () {
            this.app.router.navigate("debug/status", true);
        }

        flags () {
            this.app.router.navigate("debug/flags", true);
        }

        featureFlags () {
            this.app.router.navigate("debug/featureFlags", true);
        }

        gpsDebug () {
            this.app.router.navigate("debug/gps", true);
        }

        localStorageDebug () {
            this.app.router.navigate("debug/localStorage", true);
        }

        debugLogs () {
            this.app.router.navigate("debug/debugLogs", true);
        }

        drivingSimulator () {
            this.app.router.navigate("debug/drivingSimulator", true);
        }

        nativeDebug () {
            this.app.router.navigate("debug/native", true);
        }

        offline () {
            this.app.router.navigate("debug/offline", true);
        }

        resetAddins () {
            this.databaseCache.getSystemSettings(() => {}, true);
        }

        backgroundTest () {
            this.app.router.navigate("debug/backgroundTest", true);
        }

        vehicleProximity () {
            this.app.router.navigate("debug/vehicleProximity", true);
        }

        mocks() {
            this.app.router.navigate("debug/mocks", true);
        }

        notifications () {
            this.app.router.navigate("debug/notifications", true);
        }

        errors () {
            this.app.router.navigate("debug/errors", true);
        }

        ioxUsb() {
            this.app.router.navigate("debug/ioxUsb", true);
        }

        images() {
            this.app.router.navigate("debug/imagesDebug", true);
        }

        addin() {
            this.app.router.navigate("debug/addin", true);
        }

        webSocketDebug() {
            this.app.router.navigate("debug/webSocketDebug", true);
        }
        zenHosMain() {
            this.app.router.navigate("#/-/hos/main", true);
        }
    }